import React from 'react';
import { Button, Label, Select, SelectTrigger, SelectItem, SelectLabel, SelectGroup, SelectContent, SelectValue, } from '@cargomatic/ui';
import { Trash } from 'lucide-react';
import { equipmentTypes, equipmentSizes } from 'constants/Equipment';
import FormGrid from './FormGrid';
export default function EquipmentSizeRateConditionField({ condition, onChange, onRemove, }) {
    const { criteria: value } = condition;
    function handleRemove() {
        onRemove(condition);
    }
    function handleChange(criteria) {
        onChange(Object.assign(Object.assign({}, condition), { criteria }));
    }
    return (React.createElement(FormGrid, null,
        React.createElement(Label, { className: "w-48" }, "Equip. Size"),
        React.createElement(Select, { className: "flex-1", value: value, onValueChange: handleChange },
            React.createElement(SelectTrigger, { className: "" },
                React.createElement(SelectValue, { placeholder: "Equip. Size" })),
            React.createElement(SelectContent, null,
                React.createElement(SelectGroup, null,
                    React.createElement(SelectLabel, null, "Equip .Size"),
                    equipmentSizes.map((size) => (React.createElement(SelectItem, { value: size, key: size }, size)))))),
        React.createElement("div", null,
            React.createElement(Button, { variant: "icon", onClick: handleRemove },
                React.createElement(Trash, { className: "w-3.5 h-3.5" })))));
}
